import { render, staticRenderFns } from "./gantt-text.vue?vue&type=template&id=0656745b&scoped=true"
import script from "./gantt-text.vue?vue&type=script&lang=js"
export * from "./gantt-text.vue?vue&type=script&lang=js"
import style0 from "./gantt-text.vue?vue&type=style&index=0&id=0656745b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0656745b",
  null
  
)

export default component.exports